export default __webpack_public_path__ + "static/media/corp_mobile_banner.dffbf568.webp";